import { connect } from 'react-redux';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import ScrollToTop from '../../hoc/ScrollToTop';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Preloader from '../../components/Preloader/Preloader';
import Video from '../Video/Video';
import QuestionerDetails from '../QuestionerDetails/QuestionerDetails';
import ChatGPTUsers from '../ChatGPTUsers/ChatGPTUsers';
import ChatGPTDetails from '../ChatGPTDetails/ChatGPTDetails';
import RemindMe from '../RemindMe/RemindMe';
import StrictMenu from '../StrictMenu/StrictMenu';
import Allergies from '../Allergies/Allergies';
import Dishes from '../Dishes/Dishes';
import DishPriorities from '../DishPriorities/DishPriorities';
import AddDish from '../AddDish/AddDish';
import EditDish from '../EditDish/EditDish';
import Ingredients from '../Ingredients/Ingredients';
import Productions from '../Productions/Productions';
import AddIngredient from '../AddIngredient/AddIngredient';
import MobileUsers from '../MobileUsers/MobileUsers';
import WebUsers from '../WebUsers/WebUsers';
import MobileUserDetails from '../MobileUserDetails/MobileUserDetails';
import MobileChatGPTUsers from '../MobileChatGPTUsers/MobileChatGPTUsers';
import MobileChatGPTDetails from '../MobileChatGPTDetails/MobileChatGPTDetails';
import ChatGPTTests from '../ChatGPTTests/ChatGPTTests';
import ChatGPTTestDetails from '../ChatGPTTestDetails/ChatGPTTestDetails';
import Help from '../Help/Help';
import DeletedUsers from '../DeletedUsers/DeletedUsers';
import Blog from '../Blog/Blog';
import Authors from '../Authors/Authors';
import Banners from '../Banners/Banners';
import AddBlog from '../AddBlog/AddBlog';
import EditBlog from '../EditBlog/EditBlog';
import Settings from '../Settings/Settings';
import PageNotFound from '../PageNotFound/PageNotFound';
import DislikedProducts from '../DislikedProducts/DislikedProducts';
import SuggestedProducts from '../SuggestedProducts/SuggestedProducts';
import Login from '../Login/Login';
import styles from './App.module.css';
import PendingUsers from '../PendingUsers/PendingUsers';
import DownloadedPdfUsers from '../../components/DownloadedPdfUsers/DownloadedPdfUsers';

function App (props) {
  const { isFetching, userData } = props;

  const renderCommonRoutes = () => (
    <Route path="*" Component={PageNotFound}/>
  );

  if (!userData) {
    return (
      <div className={styles.wrapper}>
        <ScrollToTop />
        <Toaster />
        <Routes>
          <Route exact path="/" Component={Login}/>
          {renderCommonRoutes()}
        </Routes>
        <Footer />
      </div>
    );
  }

  return (
    <div className={styles.authWrapper}>
      {isFetching && <Preloader/>}
      <Toaster />
      <ScrollToTop />
      <Header />
      <Routes>
        <Route exact path="/" Component={Allergies} />
        <Route exact path="/questioner/:id" Component={QuestionerDetails} />
        <Route exact path="/chat-gpt" Component={ChatGPTUsers} />
        <Route exact path="/video" Component={Video} />
        <Route exact path="/chat-gpt/:id" Component={ChatGPTDetails} />
        <Route exact path="/remind-me" Component={RemindMe} />
        <Route exact path="/strict-menu" Component={StrictMenu} />
        <Route exact path="/dishes" Component={Dishes} />
        <Route exact path="/dish-priorities" Component={DishPriorities} />
        <Route exact path="/add-dish" Component={AddDish} />
        <Route exact path="/edit-dish/:id" Component={EditDish} />
        <Route exact path="/ingredients" Component={Ingredients} />
        <Route exact path="/products" Component={Productions} />
        <Route exact path="/disliked-products" Component={DislikedProducts} />
        <Route exact path="/suggested-products" Component={SuggestedProducts} />
        <Route exact path="/add-ingredient" Component={AddIngredient} />
        <Route exact path="/mobile-users" Component={MobileUsers} />
        <Route exact path="/web-users" Component={WebUsers} />
        <Route exact path="/mobile-user/:id" Component={MobileUserDetails} />
        <Route exact path="/mobile-chat-gpt" Component={MobileChatGPTUsers} />
        <Route exact path="/mobile-chat-gpt/:id" Component={MobileChatGPTDetails} />
        <Route exact path="/chat-gpt-tests" Component={ChatGPTTests} />
        <Route exact path="/chat-gpt-test/:id" Component={ChatGPTTestDetails} />
        <Route exact path="/help" Component={Help} />
        <Route exact path="/deleted-users" Component={DeletedUsers} />
        <Route exact path="/blog" Component={Blog} />
        <Route exact path="/authors" Component={Authors} />
        <Route exact path="/banners" Component={Banners} />
        <Route exact path="/add-blog" Component={AddBlog} />
        <Route exact path="/edit-blog/:id" Component={EditBlog} />
        <Route exact path="/pending-users" Component={PendingUsers} />
        <Route exact path="/pdf-downloads" Component={DownloadedPdfUsers} />
        <Route exact path="/settings" Component={Settings} />
        {renderCommonRoutes()}
      </Routes>
      <Footer />
    </div>
  );
}

const mapStateToProps = (state) => ({
  isFetching: state.preloader.isFetching,
  userData: state.auth.userData,
});

export default connect(mapStateToProps)(App);